import React, {useState} from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {ErrorMessageAction, LoadingAction, UpdateProjectBatchAction} from "mindsets-js-sdk";

function UpdateBatchForm({action, setBatchId, batch_id}) {
    const dispatch = useDispatch();
    const project = useSelector(state => state.project);
    const project_batches = useSelector(state => state.project_batches);
    const batch = project_batches.find(batch => batch.id === batch_id);
    const practices = useSelector(state => state.project_practices);
    const grading_providers = useSelector(state => state.grading_providers);
    const [name, setName] = useState(batch.name);
    const [practice_id, setPracticeId] = useState(batch.practice_id);
    const [grading_provider_id, setGradingProviderId] = useState(batch.grading_provider_id);
    const [completion, setCompletion] = useState(batch.completion);
    const [updated, setUpdated] = useState(false);
    const [selected_lesson_codes_string, setSelectedLessonCodesString] = useState(batch && batch.lessons ? batch.lessons.map(lesson => lesson.code).join(', ') : '');

    function validate() {
        let errors = 0;

        if (!name || '' === name) {
            dispatch(ErrorMessageAction('Error! Please specify the name of the Project Batch.'));
            errors++;
        }

        return errors === 0;
    }

    return (
        <form onSubmit={event => {
            event.preventDefault();
            if (validate) {
                dispatch(UpdateProjectBatchAction(project.id, batch.id, {
                    name,
                    practice_id,
                    grading_provider_id,
                    completion,
                    class_codes: selected_lesson_codes_string.split(',').map(item => item.trim()).filter(item => item !== '').join(',')
                })).then(() => {
                    setName('');
                    setPracticeId(null);
                    setGradingProviderId(null);
                    setCompletion(null);
                    setSelectedLessonCodesString('');
                    setBatchId(null);
                }).then(action).catch(error => {
                    dispatch(LoadingAction(false));
                    dispatch(ErrorMessageAction(error, true));
                    console.error(error);
                });
            }
        }} autoComplete="off" className='mb-3'>
            <div>
                <label htmlFor="name" className="form-label">Name</label>
                <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Name"
                    value={name}
                    onChange={event => {
                        setName(event.target.value);
                        if (!updated) {
                            setUpdated(true);
                        }
                    }}/>
            </div>
            <div>
                <label className='form-label' htmlFor='practice'>Practice/Curriculum</label>
                <div>
                    <select
                        id="practice"
                        value={practice_id ? practice_id : ''}
                        onChange={event => {
                            setPracticeId(event.target.value);
                            if (!updated) {
                                setUpdated(true);
                            }
                        }}
                    >
                        <option value=''>Please select</option>
                        {practices.map(practice => {
                            return (
                                <option value={practice.id} key={practice.id}>{practice.name}</option>
                            );
                        })}
                    </select>
                </div>
            </div>
            <div>
                <label className='form-label' htmlFor='grading_provider'>Grading Provider</label>
                <div>
                    <select
                        id="grading_provider"
                        value={grading_provider_id ? grading_provider_id : ''}
                        onChange={event => {
                            setGradingProviderId(event.target.value);
                            if (!updated) {
                                setUpdated(true);
                            }
                        }}
                    >
                        <option value=''>Please select</option>
                        {grading_providers.map(grading_provider => {
                            return (
                                <option value={grading_provider.id}
                                        key={grading_provider.id}>{grading_provider.name}</option>
                            );
                        })}
                    </select>
                </div>
            </div>
            <div>
                <label className='form-label' htmlFor='completion'>Completion</label>
                <div>
                    <select
                        id="completion"
                        value={completion ? completion : ''}
                        onChange={event => {
                            setCompletion(event.target.value);
                            if (!updated) {
                                setUpdated(true);
                            }
                        }}
                    >
                        <option value=''>Please select</option>
                        <option value='stuck'>Stuck</option>
                        <option value='underway'>Underway</option>
                        <option value='nearly'>Nearly</option>
                        <option value='completed'>Completed</option>
                        <option value='completed_bonus'>Completed bonus</option>
                    </select>
                </div>
            </div>
            <div>
                <label htmlFor='lesson-codes' className='d-block'>Class codes</label>
                <textarea
                    id='lesson-codes'
                    value={selected_lesson_codes_string}
                    onChange={event => setSelectedLessonCodesString(event.target.value)}/>
            </div>

            <div className='d-flex flex-gap-5'>
                <button type="submit" className="button">Submit</button>
                <button className="button default" onClick={event => {
                    event.preventDefault();
                    setName('');
                    setPracticeId(null);
                    setGradingProviderId(null);
                    setCompletion(null);
                    setSelectedLessonCodesString('');
                    setBatchId(null);
                }}>Cancel
                </button>
            </div>
        </form>
    );
}

UpdateBatchForm.propTypes = {
    action: PropTypes.func.isRequired,
    batch_id: PropTypes.number.isRequired,
    setBatchId: PropTypes.func.isRequired
}

export default UpdateBatchForm;
